import { render } from "./HockeyTeams.vue?vue&type=template&id=46dc1561"
import script from "./HockeyTeams.vue?vue&type=script&lang=js"
export * from "./HockeyTeams.vue?vue&type=script&lang=js"

import "./HockeyTeams.vue?vue&type=style&index=0&id=46dc1561&lang=scss"

import exportComponent from "/Users/jburnett/Documents/TBA/hockey-scheduler/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__